import React from 'react';
import { Key } from 'lucide-react';
import TokenDecoder from '../../../components/TokenDecoder.tsx';
import { PageTracker } from '../../../components/PageTracker.tsx';
import '../../../styles/dev-utils-theme.css';

export default function JwtTokenDecoder() {
  return (
    <div className="dev-utils-page" style={{ minHeight: "100vh", background: "var(--lyra-color-surface-2)", fontFamily: "'DM Sans', system-ui, sans-serif", padding: "28px 28px 48px" }}>
      <PageTracker pageTitle="JWT Token Decoder" category="dev-utils" />
      <div>
        {/* Header Section */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
            <Key size={20} style={{ color: "var(--app-primary-mid)" }} />
            <span style={{ fontSize: 22, fontWeight: 600, color: "var(--lyra-color-text)", fontFamily: "DM Sans, system-ui, sans-serif" }}>JWT Token Decoder</span>
          </div>
          <p style={{ fontSize: 13, color: "var(--app-text-2)", margin: 0 }}>Decode and analyze JWT tokens to extract payload information, verify expiration times, and debug authentication issues.</p>
        </div>

        {/* Token Decoder Component */}
        <TokenDecoder />

        {/* Information Section */}
        <div className="mt-8 bg-blue-50 dark:bg-blue-900/20 rounded-lg p-6">
          <h2 className="text-lg font-semibold text-blue-900 dark:text-blue-100 mb-3">
            About JWT Tokens
          </h2>
          <div className="text-blue-800 dark:text-blue-200 space-y-2">
            <p>
              <strong>JWT (JSON Web Token)</strong> is a compact, URL-safe means of representing claims between two parties.
            </p>
            <ul className="list-disc list-inside space-y-1 mt-3">
              <li><strong>Header:</strong> Contains the token type and signing algorithm</li>
              <li><strong>Payload:</strong> Contains the claims (user data, expiration, etc.)</li>
              <li><strong>Signature:</strong> Used to verify the token hasn't been tampered with</li>
            </ul>
            <p className="mt-3 text-sm">
              <strong>Note:</strong> This tool only decodes the payload - it doesn't verify the signature for security reasons.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
